import * as yup from 'yup';
export const patientMergeSchema = yup
    .object()
    .camelCase()
    .shape({
    id: yup.string().required().ensure(),
    primaryPatientId: yup.number().defined(),
    secondaryPatientId: yup.number().defined(),
    primaryPortalId: yup.number().defined(),
    secondaryPortalId: yup.number().defined(),
    secondaryIsArchived: yup.boolean().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
});
